// extracted by mini-css-extract-plugin
export default {"wrapper":"R3-z","play":"S3-z"};